import api from './api';

export const getBackups = async () => {
  const response = await api.get('/backup');
  return response.data;
};

export const createBackup = async () => {
  const response = await api.post('/backup/create');
  return response.data;
};

export const downloadBackup = async (filename) => {
  const response = await api.get(`/backup/download/${filename}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const restoreBackup = async (filename) => {
  const response = await api.post(`/backup/restore/${filename}`);
  return response.data;
};

export const deleteBackup = async (filename) => {
  const response = await api.delete(`/backup/${filename}`);
  return response.data;
};
